import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { Link } from "react-router-dom";
import FaqData from "../Data/FaqData.json";

const FaqData1 = () => {
  return (
    <>
      <div className="col-lg-6 col-12">
        <div className="faq-area-inner">
          <Accordion defaultActiveKey="0">
            {FaqData.slice(0, 2).map((FaqSingle) => (
              <Accordion.Item key={FaqSingle.id} eventKey={FaqSingle.eventKey}>
                <Accordion.Header>
                  <b>{FaqSingle.faqnumber}</b>
                  {FaqSingle.faqtitle}
                </Accordion.Header>
                <Accordion.Body>
                  <div className="faq-main-body">
                    {FaqSingle.faqtext}
                    <Link to="#" className="faq-readmore-btn">
                      Read more..
                    </Link>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </div>
    </>
  );
};

export default FaqData1;
